import PropTypes from 'prop-types';
import { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import { setTripSearchInputs } from '../../../../../store/slices/tripSearch';
import { autocompleteRequest } from '../../../../../store/slices/autocomplete';
import { AutocompleteType } from '../../../../../constants';
import SearchAutocomplete from '../../../../SearchAutocomplete';

const TourDestinationFilter = ({ tripId }) => {
  const isTripSearch = !tripId;
  const dispatch = useDispatch();
  const { searchInputs } = useSelector((store) => store.tripSearch);
  const storePropertyName = 'tour';
  const autocompletePropertyName = `${storePropertyName}AutocompleteResults`;
  const autocompleteResults = useSelector((store) => store.autocomplete[autocompletePropertyName]);

  const handleChange = (value) => {
    const payload = {
      ...searchInputs,
    };
    payload.tour = {
      ...payload.tour,
    };
    payload.tour.destinations = value;
    dispatch(setTripSearchInputs({ ...payload }));
  };

  useEffect(() => {
    if (!autocompleteResults || !autocompleteResults.length) {
      dispatch(
        autocompleteRequest({
          autocompleteTypes: AutocompleteType.CUSTOM,
          responseType: autocompletePropertyName,
          key: 1,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={clsx({ 'w-56': !isTripSearch, 'w-full': isTripSearch })}>
      <SearchAutocomplete
        placeholderText="Enter destination"
        onChange={(newValue) => handleChange(newValue)}
        options={autocompleteResults}
        values={searchInputs.tour.destinations || []}
        popperMinWidth={350}
        variant={isTripSearch ? [SearchAutocomplete.Variants.outlineNoRightRadius,
          SearchAutocomplete.Variants.outlineNoBorderWidth] : undefined}
        disableClearable
        doUseThemeBackground
        bgClassName={isTripSearch ? 'bg-searchInput-0' : ''}
      />
    </div>
  );
};

TourDestinationFilter.propTypes = {
  tripId: PropTypes.string,
};

TourDestinationFilter.defaultProps = {
  tripId: undefined,
};

export default memo(TourDestinationFilter);
